var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPlay = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .play-class-a {\n                fill: none !important;\n            }\n\n            .play-class-b,\n            .play-class-c {\n                fill: #fff;\n            }\n\n            .play-class-b {\n                fill-rule: evenodd;\n            }\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "play-class-a",
    width: 44,
    height: 44
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-163 -156)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(167.705 160.684)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "play-class-b",
    d: "M119.858,379.152a14.294,14.294,0,1,0,14.294-14.294A14.294,14.294,0,0,0,119.858,379.152Zm-2.858,0A17.152,17.152,0,1,0,134.152,362,17.153,17.153,0,0,0,117,379.152Z",
    transform: "translate(-117 -362)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "play-class-c",
    d: "M9,7.083V19.228a.313.313,0,0,0,.468.288L19.1,13.444a.344.344,0,0,0,0-.572L9.468,6.8A.31.31,0,0,0,9,7.083Z",
    transform: "translate(171.751 164.844)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPlay);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_play.3e4b43b7c3564565ee35f3e1c2678b45.svg";